import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import WaitlistListComp from '../component/fpg/list/WaitlistListComp'
import FilterActiveIcon from '../icons/filteractiveicon'
import WaitlistRefreshIcon from '../icons/WaitlistRefreshIcon'
import PlusIcon from '../icons/plusicon'
import MainLayout from '../mainLayout'
//moment import
import moment from "moment-timezone";
//Service import
import service from "../services";
let sub;
export default class WaitlistList extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
            getLastUpdated: '',
            loaderFlag: false,
            data:[
                {
                    "label":"Waitlist Management",
                    "Content":"This is content for Tab 1",
                }
            ],
            emailTemplateListDocs: [],
        }
        this.intervalId = null;
        this.apiserve = new service();
    }

    componentDidMount() {
        this.getProductLastUpdate();
        this.getLastUpdatedTimeandDate();
        this.getAllProductCouponList();
        this.intervalId = setInterval(this.getAllProductCouponList, 60000)
         this.setState({
           loaderFlag: true,
         });
       }

       componentWillUnmount(){
        clearInterval(this.intervalId);
        sub.unsubscribe();
       }
    
       getProductLastUpdate = () => {
        sub = this.apiserve.getevent().subscribe((response) => {
            switch(response.event){
                case 'ticketCms|products|getLastUpdated':
                    this.setState({
                        getLastUpdated : response.data
                    })
                    break;
                case "admin|waitlistStats":
                    if(!response.error){
                        this.setState({
                            emailTemplateListDocs: response.data,
                            loaderFlag: false,
                        });
                    } else {                  
                        this.setState({
                            loaderFlag: false,
                        });
                    }
                    break;
            }
        })
    }

    getAllProductCouponList = () => {
        this.apiserve.sendevent("admin|waitlistStats", {});
    };

    getLastUpdatedTimeandDate = () => {
        this.apiserve.sendevent("ticketCms|products|getLastUpdated", { type: 1 });
    }

    render() {
        const { getLastUpdated } = this.state;
        var updateAt = new Date(getLastUpdated && getLastUpdated.updatedAt);
        var hour = moment.tz(updateAt, "US/Mountain").format("h");
        var minutes = moment.tz(updateAt, "US/Mountain").format("mm");
        var state = moment.tz(updateAt,"US/Mountain").format("A");
        var updatedBy = getLastUpdated && getLastUpdated.updatedBy;
        return (
            <React.Fragment>
                <div className="right_side_wrapper sd_waitlist_tab">
                    <ul className="fpg_admin_tab disp_flex">
                        {
                            this.state.data && this.state.data.map((list,index) => {
                                return(
                                    <li className="active" >
                                        <p className="uppercase text_left">
                                         <div>{list.label}</div>
                                        </p>
                                        <button className='sd_refresh_btn' onClick={() => this.getAllProductCouponList()}><WaitlistRefreshIcon/></button>
                                    </li>
                                )
                            })
                        }
                    </ul>
                   
                    {/* <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                        <p></p>
                        <p className="update_date">Last Update: {hour}:{minutes} {state} -{" "}
                        {moment.tz(updateAt,"US/Mountain").format("MM/DD/YYYY")} Last Updated By:{" "}
                        {updatedBy && updatedBy.fname} {updatedBy && updatedBy.lname}</p>
                    </div> */}
                    <div className="table_wrap product_list_tbl">
                        <WaitlistListComp history={this.props.history} emailTemplateListDocs={this.state.emailTemplateListDocs} loaderFlag={this.state.loaderFlag}/>
                    </div>                               
                </div>
        </React.Fragment>  
        )
    }
}
